import { Injectable } from '@angular/core';
import { Observable, Subject, observable, throwError } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HelperService } from './helper.service';

export class Message {
  constructor(public author: string, public content: string, public timeStamp: string, public planText: string, public codeText: string, public messageId: string, public is_dislike: number) { }
}

@Injectable(
  {providedIn: 'root'
  }
)
export class CoPilotService {
  private webSocket: WebSocket;
  public readonly webSocketSubject: Subject<MessageEvent>;
  private baseURL: string = environment.conversational_ai_base_url;

  constructor(public helperService: HelperService) {
    this.webSocketSubject = new Subject();
  }

  conversation = new Subject<Message[]>();

  public initializeWebSocket(token,queryParams,status): void {
    // //console.log("inside websocket service");
    if (status == '' || status == 'open') {
      let indexName = `index_name=${queryParams.index_name}`
      let pipelineName = `pipeline_name=${queryParams.pipeline_name}`
      // let modelId = `model_id=${queryParams.model_id}`
      let conversationId = `conversation_id=${queryParams.conversation_id}`
      this.webSocket = new WebSocket(this.baseURL + "?" + indexName + "&" + pipelineName + "&" + conversationId + "&message_history_limit=10");
      let newToken = { 'api-key': token };
      //console.log(queryParams)
     
      // let newToken = {"api-key": "$2b$12$yVHmB/tBgB4dMtXi6jcNeOWRCrzMZsLeiRdAVRo9bNH.dc57/8c2y"};
      this.webSocket.onopen = () => {
        //console.log('WebSocket connection established.');
        this.sendMessage(newToken);
      };
      // if (status == '') {
      //   setTimeout(() => {
      //     this.webSocket.close();
      //   }, 9000);
      // } else if (status == 'open') {
      //   setTimeout(() => {
      //     this.webSocket.close();
      //   }, 900000);
      // }
    } else if (status == 'close') {
      if (this.webSocket.readyState == 1) {
        //console.log('Web sockect connection close ');
        this.webSocket.close();
      }
    }
    this.webSocket.onmessage = (message) => {
      this.webSocketSubject.next(message);
    };
    this.webSocket.onerror = (error) => {
      //console.log('on error connection', error);
      this.webSocketSubject.error(error);
    };
    this.webSocket.onclose = (e) => {
      //console.log('on close connection', e.reason);
      if (e.wasClean) {
        if (e.reason != '') {
          if (e.reason != 'keepalive ping timeout') {
            this.helperService.presentToast('connection timeout', 3000);
          } else {
            this.helperService.presentToast(e.reason, 3000);
          }
        }
      }
    };
  }

  closeWebSocket() {
    //console.log(this.webSocket)
    if (this.webSocket) {
      if (this.webSocket.readyState == 1) {
        //console.log('Web sockect connection close');
        this.webSocket.close();
      }
    }
  }

  sendMessage = async (msg) => {
    //console.log(msg)
    if (this.webSocket.readyState !== this.webSocket.OPEN) {
      try {
        await this.waitForOpenConnection(this.webSocket);
        //console.log(msg)
        this.webSocket.send(JSON.stringify(msg));
      } catch (err) {
        console.error(err);
      }
    } else {
      //console.log(msg)
      this.webSocket.send(JSON.stringify(msg));
    }
  };

  waitForOpenConnection = (socket) => {
    return new Promise<void>((resolve, reject) => {
      const maxNumberOfAttempts = 10;
      const intervalTime = 200; //ms

      let currentAttempt = 0;
      const interval = setInterval(() => {
        if (currentAttempt > maxNumberOfAttempts - 1) {
          clearInterval(interval);
          reject(new Error('Maximum number of attempts exceeded'));
        } else if (socket.readyState === socket.OPEN) {
          clearInterval(interval);
          resolve();
        }
        currentAttempt++;
      }, intervalTime);
    });
  };

  public getMessages(): Observable<MessageEvent> {
    return this.webSocketSubject.asObservable().pipe(
      share(),
      catchError((err) => this.handleError(err))
    );
  }

  private handleError(error: Error): Observable<never> {
    // Notify user, attempt reconnection, etc.
    //console.log(error);
    return throwError(error);
  }

  messageMap = {
    'Hi': 'Hello',
    'Who are you': 'My name is Co-pilot',
    'What is Co-pilot ': 'Co-pilot is the chat bot',
    'default': "I can't understand. Can you please repeat",
  };

  getBotAnswer(msg: string,botAnswer: string) {
    //console.log(botAnswer)
    const userMessage = new Message('user', msg, "", "", "", "", 0);
    this.conversation.next([userMessage]);
    const botMessage = new Message('bot', botAnswer, "", "", "", "", 0);

    setTimeout(() => {
      this.conversation.next([botMessage]);
    }, 1500);
  }


}
